import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from "react";
import { Group, Progress, Stack, Text } from "@mantine/core";
import dayjs from "dayjs";
import BoxContainer from "../BoxContainer";
import { STATUS_COLOR, TEXT_COLOR } from "../theme/colors";
const SimpleProgressBar = ({ step, estimatedStartTimestamp, estimatedEndTimestamp, error, }) => {
    const startDt = estimatedStartTimestamp
        ? dayjs(estimatedStartTimestamp)
        : dayjs();
    const endDt = dayjs(estimatedEndTimestamp);
    const totalEstimatedTimeInS = endDt.diff(startDt, "seconds");
    const [timeRemainingInS, setTimeRemainingInS] = useState(totalEstimatedTimeInS);
    const incrementBy = 100 / totalEstimatedTimeInS;
    const incrementIntervalInMillis = 1000;
    const [percentCompleted, setPercentCompleted] = useState(0);
    useEffect(() => {
        const interval = setInterval(() => setPercentCompleted((prev) => Math.round(prev < 100 ? Math.min(prev + incrementBy, 100) : prev)), incrementIntervalInMillis);
        return () => {
            clearInterval(interval);
        };
    }, []);
    useEffect(() => {
        if (percentCompleted < 100) {
            setTimeRemainingInS((prev) => prev - incrementIntervalInMillis / 1000);
        }
    }, [percentCompleted]);
    return (_jsxs(BoxContainer, { p: 32, border: false, children: [_jsxs(Stack, { align: "center", spacing: 4, children: [_jsx(Text, { size: "sm", weight: 500, children: step }), percentCompleted < 100 && (_jsx(Text, { size: "sm", color: TEXT_COLOR.SECONDARY, children: totalEstimatedTimeInS > 60 && `This may take a few minutes` }))] }), _jsxs(Group, { mt: 20, position: "apart", children: [_jsxs(Text, { size: "sm", children: [percentCompleted || 0, "% complete"] }), timeRemainingInS > 0 && (_jsxs(Text, { size: "sm", color: TEXT_COLOR.SECONDARY, children: ["~", timeRemainingInS, "s remaining"] }))] }), _jsx(Progress, { mt: 4, color: TEXT_COLOR.PRIMARY, radius: 33, value: percentCompleted }), error && (_jsx(_Fragment, { children: _jsx(BoxContainer, { mt: 32, border: false, children: _jsx(Stack, { align: "center", spacing: 0, children: _jsx(Text, { size: "xs", color: STATUS_COLOR.ERROR, children: error }) }) }) }))] }));
};
export default SimpleProgressBar;
